import { render, staticRenderFns } from "./ContactsList.vue?vue&type=template&id=39d4ec0c&scoped=true&"
import script from "./ContactsList.vue?vue&type=script&lang=js&"
export * from "./ContactsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d4ec0c",
  null
  
)

export default component.exports